<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <video class="bg-video" autoplay loop muted playsinline>
        <source src="@/assets/1678779171725-jwprOaEf.mp4" type="video/mp4">
      </video>
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <PageHeader :showNav="false" activeNavKey="overview"/>

        <div class="center">
          <div class="center-header">
            <div class="nav-tabs">
              <div style="font-size: 25px;font-weight: bold;"
                  v-for="(item, index) in navTabs" :key="index"
                   :class="['nav-tab-item', { active: activeTab === index }]"
                   @click="handleTabClick(index)">
                {{ item }}
              </div>
            </div>
          </div>

          <!-- 主要内容区域 -->
          <div class="main-content">
            <!-- 上半部分：左右布局 -->
            <div class="top-section">
              <!-- 左侧：宏观总览 -->
              <div class="left-section">
                <div class="section-title-bg"></div>
                <div class="section-title">
                  <!-- <span class="title-icon">🧭</span> -->
                  <span class="title-text">宏观总览</span>
                </div>

                <!-- 数据卡片 -->
                <div class="data-cards">
                  <div v-for="(item, index) in macroData" :key="index" class="data-card"
                       :style="{ '--card-color': '#00d9ff', backgroundImage: 'url(' + item.bg + ')' }">
                    <!-- <div class="card-accent-bar"></div>
                      <div class="card-corner-triangle"></div> -->
                    <div class="card-icon"><img :src="item.icon" alt=""
                                                style="width: 100%; height: 100%;"></div>
                    <div class="card-content">
                      <div class="card-label">{{ item.label }}</div>
                      <div class="card-value-wrapper">
                        <span class="card-value">{{ item.value }}</span>
                        <span class="card-unit">{{ item.unit }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 右侧：统计数据 -->
              <div class="right-section">
                <div class="statistics-cards">
                  <div v-for="(item, index) in statisticsData" :key="index" class="statistics-card">
                    <div class="stat-icon">
                      <img :src="item.icon" alt=""
                           style="width: 100%; height: 100%; object-fit: contain;">
                    </div>
                    <div class="stat-content">
                      <span class="stat-label">{{ item.label }}</span>
                      <span class="stat-value">{{ item.value }}</span>
                      <span class="stat-unit">({{ item.unit }})</span>
                      <span class="stat-period">({{ item.period }})</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 下半部分：企业类型及分布 - 一行铺满 -->
            <div class="bottom-section">
              <EnterpriseDistribution/>
            </div>

            <!-- 产改进行时 和 企业经济动态 - 左右布局 -->
            <div class="reform-economic-section">
              <!-- 左侧：产改进行时 -->
              <div class="reform-section">
                <ReformProgress/>
              </div>
              <!-- 右侧：企业经济动态 -->
              <div class="economic-section">
                <EconomicDynamics/>
              </div>
            </div>
          </div>
          <!-- Footer 组件 -->
          <div class="footer-container">
            <PageFooter/>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import drawMixin from '../utils/drawMixin'
import EnterpriseDistribution from '../components/enterprise-distribution/index.vue'
import ReformProgress from '../components/reform-progress/index.vue'
import EconomicDynamics from '../components/economic-dynamics/index.vue'
import PageHeader from '../components/page-header/index.vue'
import bank from '../assets/bank.png'
import money1 from '../assets/m2.png'
import money2 from '../assets/mony2.png'
import indexBottomImg from '../assets/index-bottom.png'
import {get} from '@/utils/request.js'
import PageFooter from '../components/page-footer/index.vue'

export default {
  mixins: [drawMixin],
  components: {
    PageFooter,
    EnterpriseDistribution,
    ReformProgress,
    EconomicDynamics,
    PageHeader,
  },
  data() {
    return {
      VUE_APP_API_BASE_URL: "https://dp.houkongfan.cn",
      qycyList: [],     // 产业类型列表
      qylxfbList: [],   // 企业类型分布列表
      qychList: [],     // 企业称号分布列表
      cgjxsList: [],     // 产改进行时列表
      qyjjdtList: [],    // 企业经济动态列表
      decorationColor: ['#568aea', '#000000'],
      loading: true,
      activeTab: 0, // 当前激活的标签索引
      navTabs: ['产改总览', '产改蓝图', '产业洞察', '企业观察'], // 导航标签
      // 宏观总览数据
      macroData: [{
        label: '全镇企业数量',
        value: '2,377',
        unit: '家',
        icon: require('@/assets/page1/1761987606177-OHNHdaXc.png'),
        bg: require('@/assets/page1/1678419205418-a3E3pEj7.png'),
      },
        {
          label: '全镇职工人数',
          value: '27,560',
          unit: '人',
          icon: require('@/assets/page1/1761987618431-vB34Duyh.png'),
          bg: require('@/assets/page1/1678419206180-21r-hY8E.png')
        },
        {
          label: '主导产业链企业',
          value: '1,228',
          unit: '家',
          icon: require('@/assets/page1/1761987641978-fY3XYAZe.png'),
          bg: require('@/assets/page1/1678419206180-21r-hY8E.png')
        },
        {
          label: '主导产业覆盖率',
          value: '95.60',
          unit: '%',
          icon: require('@/assets/page1/1761987655044-bhdwh0TE.png'),
          bg: require('@/assets/page1/1678419208028-foajAi-F.png')
        },
      ],
      // 统计数据
      statisticsData: [{
        label: '总产值',
        value: '228.6',
        unit: '亿元',
        period: '2025年1-9月',
        icon: bank
      },
        {
          label: '开票销售',
          value: '182.00',
          unit: '亿元',
          period: '2025年1-9月',
          icon: money1
        },
        {
          label: '入库税金',
          value: '15.99',
          unit: '亿元',
          period: '2024年',
          icon: money2
        },
      ],
      indexBottomImg,
    }
  },
  mounted() {
    this.cancelLoading()
    this.setActiveTabByRoute()
    this.fetchUserData()
    // 确保在加载完成后重新计算缩放
    this.$nextTick(() => {
      setTimeout(() => {
        this.calcRate()
      }, 600)
    })
  },
  watch: {
    '$route'() {
      this.setActiveTabByRoute()
    }
  },
  beforeDestroy() {
  },
  methods: {
    // 获取数据
    async fetchUserData() {
      this.loading = true
      const url = this.VUE_APP_API_BASE_URL + "/dev-api/system/page1/queryList/model1"
      const result = await get(url)
      if (result.success) {

        // 从API响应中提取数据
        const rowData = result.data.zpzlList[0]

        // 更新宏观总览数据
        this.macroData[0].value = rowData.enterprisesNumber.toString();
        this.statisticsData[0].value = rowData.totalOutputValue;
        this.statisticsData[0].period = rowData.totalOutputDesc;
        this.statisticsData[0].unit = rowData.totalOutputUnit;

        this.macroData[1].value = rowData.employeesNumber.toString();
        this.statisticsData[1].value = rowData.invoiceSalesValue;
        this.statisticsData[1].period = rowData.invoiceSalesDesc;
        this.statisticsData[1].unit = rowData.invoiceSalesUnit;

        this.macroData[2].value = rowData.leadingindustryNumber.toString();
        this.statisticsData[2].value = rowData.importDutyValue;
        this.statisticsData[2].period = rowData.importDutyDesc;
        this.statisticsData[2].unit = rowData.importDutyUnit;

        this.macroData[3].value = rowData.leadinglndustryCoverage;
        this.loading = false
      }
    }
    ,
    // loading效果
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 根据路由设置激活的标签
    setActiveTabByRoute() {
      const routeMap = {
        '/': 0,
        '/blueprint': 1,
        '/insight': 2,
        '/benchmark': 3
      }
      this.activeTab = routeMap[this.$route.path] || 0
    },
    // 处理标签点击
    handleTabClick(index) {
      this.activeTab = index
      // 根据标签切换路由
      const routes = ['/', '/blueprint', '/insight', '/enterprise']
      if (routes[index] && this.$route.path !== routes[index]) {
        this.$router.push(routes[index])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.footer-container {
  position: absolute;
  bottom: 80px;
}

.center-header {
  //font-family: Arial, Helvetica, sans-serif;
  font-family: 'SimSun', '宋体', sans-serif;
  font-weight: bold;
  width: 100%;
  font-size: 40px;
  height: 35px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

  // margin-bottom: 20px;
  .center-header-size {
    padding: 0 10px;
    letter-spacing: 2px;
    font-weight: 700;
    background: linear-gradient(92deg,
        #0072ff 0%,
        #00eaff 48.8525390625%,
        #01aaff 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

// center 区域样式调整
.center {
  position: relative;
  padding-bottom: 100px; // 为底部图片留出空间
}

.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.3;
  z-index: 0;
  pointer-events: none;
}

// 主要内容区域
.main-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 20px;
  margin-top: 20px;


  // 上半部分：左右布局
  .top-section {
    display: flex;
    gap: 20px;

    // 左侧：宏观总览
    .left-section {
      flex: 1;
      margin-top: 20px;
      position: relative;

      .section-title-bg {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url('~@/assets/page1/1678762309227-E6RP8z2R.png');
        mask-image: none;
        height: 35px;
        width: 500px;

      }

      .section-title {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        position: absolute;
        top: 8px;
        left: 0;

        .title-icon {
          font-size: 28px;
        }

        .title-text {
          position: relative;
          padding-bottom: 8px;
          margin-left: 10px;

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background: linear-gradient(90deg, #00d9ff, transparent);
          }
        }
      }

      // 数据卡片
      .data-cards {

        display: flex;
        gap: 15px;
        margin-top: 20px;

        .data-card {
          flex: 1;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          mask-image: none;
          mask-repeat: initial;
          mask-size: initial;
          background-color: initial;
          border-radius: 0px;
          cursor: pointer;
          padding: 20px 24px 22px 24px;
          position: relative;
          overflow: hidden;
          transition: all 0.3s;


          // 左侧彩色条
          .card-accent-bar {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 4px;
            background: var(--card-color);
          }

          // 右下角三角形装饰
          .card-corner-triangle {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 20px 20px;
            border-color: transparent transparent var(--card-color) transparent;
            opacity: 0.3;
          }

          .card-icon {
            position: absolute;
            top: 18px;
            right: 18px;
            font-size: 44px;
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;

          }

          .card-content {
            width: 100%;

            .card-label {
              font-size: 20px;
              color: #6b7d8f;
              margin-bottom: 10px;
              padding-right: 80px;
            }

            .card-value-wrapper {
              display: flex;
              align-items: baseline;
              gap: 12px;

              .card-value {
                font-size: 36px;
                font-weight: 700;
                color: #fff;
                line-height: 1.2;
              }

              .card-unit {
                font-size: 16px;
                color: #6b7d8f;
              }
            }
          }
        }
      }
    }

    // 右侧：统计数据
    .right-section {
      width: 600px;
      flex-shrink: 0;
      display: flex;
      align-items: flex-start;

      .statistics-cards {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;

        .statistics-card {
          background: rgba(7, 20, 36, 0.45);
          border: 1px solid rgba(0, 217, 255, 0.12);
          border-radius: 12px;
          padding: 10px 18px;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 12px;
          transition: all 0.3s;

          &:hover {
            background: rgba(7, 20, 36, 0.6);
            border-color: rgba(0, 217, 255, 0.35);
            transform: translateX(4px);
            box-shadow: 0 6px 16px rgba(0, 217, 255, 0.18);
          }

          .stat-icon {
            font-size: 26px;
            width: 42px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            // background: rgba(0, 217, 255, 0.08);
            // border-radius: 8px;
            flex-shrink: 0;
          }

          .stat-content {
            flex: 1;
            display: flex;
            align-items: flex-end;
            gap: 10px;
            flex-wrap: nowrap;

            .stat-label {
              font-size: 30px;
              font-weight: 900;
              letter-spacing: 1px;
              line-height: 1;
            }

            .stat-value {
              font-size: 32px;
              font-weight: 900;
              color: #fff;
              line-height: 1;
            }

            .stat-unit {
              font-size: 14px;
              font-weight: 700;
              color: #8aa2b5;
            }

            .stat-period {
              font-size: 14px;
              font-weight: 700;
              color: #8aa2b5;
            }
          }
        }

        // 每行专属主题色：1蓝、2青绿、3红
        .statistics-card:nth-child(1) {
          background-repeat: repeat-y;
          background-size: 100%;
          background-image: url('~@/assets/page1/1678774467032-YyreRREB.png');

          .stat-icon {
            // background: rgba(0, 181, 255, 0.12);
          }

          .stat-label {
            color: #0f94c2;
          }
        }

        .statistics-card:nth-child(2) {
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url('~@/assets/page1/1678774467835-3hyyeaoW.png');

          .stat-icon {
            // background: rgba(0, 224, 164, 0.12);
          }

          .stat-label {
            color: #00e8ad;
          }
        }

        .statistics-card:nth-child(3) {
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url('~@/assets/page1/1678774467835-3hyyeaoW.png');

          .stat-icon {
            // background: rgba(255, 91, 107, 0.12);
          }

          .stat-label {
            color: #ff456a;
          }
        }
      }
    }
  }

  // 下半部分：企业类型及分布 - 一行铺满
  .bottom-section {
    width: 100%;
    height: 450px;
  }

  // 产改进行时 和 企业经济动态 - 左右布局
  .reform-economic-section {
    display: flex;
    gap: 20px;
    width: 100%;
    height: 280px;

    // 左侧：产改进行时
    .reform-section {
      flex: 1;
      min-width: 0;
    }

    // 右侧：企业经济动态
    .economic-section {
      width: 600px;
      flex-shrink: 0;
    }
  }

  // 底部图片
  .bottom-images {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
    width: calc(100% - 40px);
    padding: 0 20px;
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    z-index: 1000;
    pointer-events: none;
    gap: 2%;
    box-sizing: border-box;

    .bottom-image {
      position: relative;
      z-index: 1000;
      pointer-events: auto;
      width: 49%;
      flex: 0 0 49%;
      max-width: 49%;
      box-sizing: border-box;
      overflow: visible;

      img {
        display: block;
        height: auto;
        width: 100%;
        max-width: 100%;
        max-height: 200px;
        object-fit: contain;
      }

      &.left {
        // 左侧图片正常显示
      }

      &.right {

        // 右侧图片镜像翻转
        img {
          transform: scaleX(-1);
        }
      }
    }
  }
}
</style>
